import { ref } from 'vue'
import { useUsersStore } from '@/stores/modules/users.ts'
import { buffer2Base64 } from '@/helpers/Func'

export function useProfileImage() {
	const userStore = useUsersStore()
	const loadingProfiIeImage = ref(false)
	const hasProfileImage = ref(false)
	const profileImage = ref<string | undefined | null>()

	const loadProfileImage = async (user: Api.User | Api.WhoAmI) => {
		if (!user?.profile_image) {
			hasProfileImage.value = false
			profileImage.value = null
			return
		}
		hasProfileImage.value = true
		loadingProfiIeImage.value = true
		try {
			const userImage = await userStore.loadImage(user.id)
			profileImage.value = buffer2Base64(userImage) ?? null
		} catch {
			profileImage.value = null
		} finally {
			loadingProfiIeImage.value = false
		}
	}

	return {
		loadProfileImage,
		hasProfileImage,
		profileImage,
		loadingProfiIeImage,
	}
}
